<h2 mat-dialog-title>Import Data</h2>
<mat-dialog-content class="mat-typography">
  <mat-stepper #stepper animationDuration="400" [disableRipple]="true" (selectionChange)="onStepChange($event)">

    <mat-step [stepControl]="initForm" label="upload" [editable]="false">
      <form [formGroup]="initForm">
        <ng-template matStepLabel>Upload File</ng-template>
        <h3 *ngIf="fileName.length === 0">Please upload a file in the XLSX or CSV format.</h3>
        <h3 *ngIf="fileName.length">Please select a sheet to use for import. <br>The uploaded file should contain an obligatory filled field <b>'Product ID'</b>.
        </h3>
        <div class="file-name">{{fileName}}</div>
        <button type="button" *ngIf="fileName.length === 0" mat-raised-button (click)="fileInput.click()">{{fileName ? "Replace File" : "Choose File"}}</button>
        <input hidden (change)="uploadFile($event)" #fileInput type="file" id="file">

        <div *ngIf="uploadProgress !== null" style="margin: 12px 0;">
          <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
          <p style="margin-top: 8px; font-size: 13px; opacity: 0.75;">Uploading — {{uploadProgress}}%</p>
        </div>

        <div *ngIf="analyzingFile" style="margin: 12px 0;">
          <mat-progress-bar
            [mode]="analysisProgress?.phase === 'counting' ? 'determinate' : 'indeterminate'"
            [value]="analysisProgress?.percent || 0"></mat-progress-bar>
          <p style="margin-top: 8px; font-size: 13px; opacity: 0.75;">
            <ng-container *ngIf="!analysisProgress">Analyzing file...</ng-container>
            <ng-container *ngIf="analysisProgress?.phase === 'parsing'">Reading file — {{analysisProgress.rows | number}} rows...</ng-container>
            <ng-container *ngIf="analysisProgress?.phase === 'counting'">Matching against the catalog — {{analysisProgress.completed | number}} / {{analysisProgress.total | number}}</ng-container>
          </p>
        </div>

        <div class="top-selects-grid" *ngIf="initFormReady">
          <mat-form-field appearance="fill">
            <mat-label>Select Sheet</mat-label>
            <mat-select formControlName="table" required (selectionChange)="onTableChange($event)">
              <mat-option *ngFor="let table of tables" [value]="table.value">
                {{table.viewValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>

<!--          <mat-form-field appearance="fill">-->
<!--            <mat-label>Select Brand</mat-label>-->
<!--            <mat-select formControlName="brand" (selectionChange)="onBrandChange($event)" required>-->
<!--              <mat-option *ngFor="let brand of brands" [value]="brand._id">-->
<!--                {{brand.name}}-->
<!--              </mat-option>-->
<!--            </mat-select>-->
<!--          </mat-form-field>-->

<!--          <mat-form-field appearance="fill">-->
<!--            <mat-label>Select SKU</mat-label>-->
<!--            <mat-select formControlName="skuField" required (selectionChange)="onIdentityFieldChange($event)">-->
<!--              <mat-option *ngFor="let header of tableHeaders" [value]="header.value">-->
<!--                {{header.viewValue}}-->
<!--              </mat-option>-->
<!--            </mat-select>-->
<!--          </mat-form-field>-->
        </div>
      </form>
    </mat-step>


    <mat-step label="update" [stepControl]="updateForm" *ngIf="update" [editable]="false">
      <div class="grid-2">
        <div>
          <h3>Please match the source sheet fields with the database fields. Please uncheck the source sheet fields if synchronization for them is not required.</h3>
          <mat-progress-bar *ngIf="importUpdateProgressBar" mode="indeterminate"></mat-progress-bar>
          <br>
          <br>
        </div>
        <div>
          <form [formGroup]="updateForm">
<!--            <button (click)="toggleUpdate()">Toggle Checkboxes</button>-->
            <button (click)="deselectUpdate()">Deselect All</button>
            <br>
            <br>
            <ng-template matStepLabel>Update Products <span *ngIf="findProductsUpdates" style="color:#f44336;font-weight:500;">({{findProductsUpdates}})</span></ng-template>
            <div class="header-association"  *ngFor="let item of updateFormAssociationsFields; let i = index">
              <mat-form-field appearance="fill">
                <mat-label>{{item.viewValue}}</mat-label>
                <mat-select [formControlName]="item.value" (selectionChange)="onUpdateAssociate(item, $event)" required>
                  <mat-option *ngFor="let row of gridRows" [value]="row.value">
                    {{row.viewValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

<!--              <mat-form-field *ngIf="item.viewValue === 'tags'">-->
<!--                <mat-select formControlName="tagsMethodUpdate">-->
<!--                  <mat-option *ngFor="let row of tagsUpdateMethod" [value]="row.value">-->
<!--                    {{row.viewValue}}-->
<!--                  </mat-option>-->
<!--                </mat-select>-->
<!--              </mat-form-field>-->
              <div class="more-action">
                <mat-checkbox class="example-margin" color="primary" [checked]="!updateForm.controls[item.value].disabled" (change)="onCheckBox($event, item, i, 'updateForm')"></mat-checkbox>
              </div>
            </div>
          </form>
        </div>
      </div>
    </mat-step>


    <mat-step label="create" [stepControl]="createForm" *ngIf="create" [editable]="false">
      <div class="grid-2">
        <div>
          <h3>Please match the source sheet fields with the database fields. Please uncheck the source sheet fields if synchronization for them is not required.</h3>
          <mat-progress-bar *ngIf="importCreateProgressBar" mode="indeterminate"></mat-progress-bar>
          <br>
          <br>
          <br>
          <br>
          <br>
        </div>
        <div>
          <form [formGroup]="createForm">
<!--            <button (click)="toggleCreate()">Toggle Checkboxes</button>-->
            <button (click)="deselectCreate()">Deselect All</button>
            <br>
            <br>
            <ng-template matStepLabel>Create Products <span *ngIf="findProductsCreates" style="color:#f44336;font-weight: 500;">({{findProductsCreates}})</span></ng-template>
            <div class="header-association"  *ngFor="let item of createFormAssociationsFields; let i = index">
              <mat-form-field appearance="fill">
                <mat-label>{{item.viewValue}}</mat-label>
                <mat-select [formControlName]="item.value" (selectionChange)="onCreateAssociate(item, $event)" required>
                  <mat-option *ngFor="let row of gridRows" [value]="row.value">
                    {{row.viewValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div class="more-action">
                <mat-checkbox class="example-margin" color="primary" [checked]="!createForm.controls[item.value].disabled" (change)="onCheckBox($event, item, i, 'createForm')"></mat-checkbox>
              </div>
            </div>
          </form>
        </div>
      </div>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>


<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
<!--  <button mat-button *ngIf="fileName.length && selectedStep !== 'create' && (findProductsUpdates && findProductsCreates)" [disabled]="initForm.invalid || initForm.disabled || lockUpdateButton" (click)="skipUpdate()">Skip Update</button>-->
  <button mat-button *ngIf="fileName.length && selectedStep !== 'create' && selectedStep !== 'upload' && (findProductsUpdates && findProductsCreates)" [disabled]="initForm.invalid || initForm.disabled || lockUpdateButton" (click)="skipUpdate()">Skip Update</button>
  <button mat-raised-button color="primary" *ngIf="fileName.length && selectedStep === 'upload'" [disabled]="initFormNextButtonDisabled || initForm.invalid || initForm.disabled" (click)="nextStep()">{{analyzingFile ? 'Analyzing...' : 'Continue'}}</button>
<!--  <button mat-raised-button color="primary" *ngIf="selectedStep === 'update'" [disabled]="updateForm.invalid || updateForm.disabled || lockUpdateButton" (click)="updateProducts()">Update {{findProductsUpdates}} Products</button>-->
  <mat-slide-toggle color="primary" style="margin-left: 28px; margin-right: 24px;" *ngIf="selectedStep === 'update'"
                    [(ngModel)]="autoSyncAfterImport" [ngModelOptions]="{standalone: true}" [disabled]="lockUpdateButton"
                    matTooltip="When the import finishes, Update & Sync starts automatically using your preferred sync mode">
    Auto-sync to Shopify after import
  </mat-slide-toggle>
  <mat-checkbox color="primary" style="margin-right: 12px;" *ngIf="selectedStep === 'update' && findProductsCreates" [checked]="skipCreation" [disabled]="lockUpdateButton" (change)="skipCreation = $event.checked">Skip creating {{findProductsCreates}} new parts</mat-checkbox>
  <button title="new" mat-raised-button color="primary" *ngIf="selectedStep === 'update'" [disabled]="updateForm.invalid || updateForm.disabled || lockUpdateButton" (click)="newUpdateProducts()">Update {{findProductsUpdates}} Products</button>
  <button mat-button [disabled]="lockCreateButton" *ngIf="selectedStep === 'create'" (click)="close()">Skip Creation</button>
  <button mat-raised-button color="primary" *ngIf="selectedStep === 'create'" [disabled]="createForm.invalid || createForm.disabled || lockCreateButton" (click)="createProducts()">Create {{findProductsCreates}} Products</button>
</mat-dialog-actions>
